const state = {
  drawer: null,
  responsive: false,
};

const getters = {
  drawer: (state) => state.drawer,
  responsive: (state) => state.responsive,
};

const actions = {};

const mutations = {
  setDrawer(state, value) {
    state.drawer = value;
  },
  toggleDrawer(state) {
    state.drawer = !state.drawer;
  },
  setResponsive(state, value) {
    state.responsive = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
